<template>
  <div class="layout_c">
    <div class="top">
      <top />
    </div>
    <div class="member-right-navbar-index">
      <app-main class="main"></app-main>
    </div>
  </div>
</template>

<script>
import top from "./top.vue";
import AppMain from "./main.vue";
export default {
  components: {
    top,
    AppMain,
  },
  data() {
    return {
    };
  },
};
</script>

<style scoped lang="less">
html, body {
  margin: 0;
  padding: 0;
  overflow: hidden;
}

.layout_c {
  background-color: #f2f3f4;
  min-width: 1200px;
  overflow: hidden;
  position: relative;
  height: 100vh;
}

.member-right-navbar-index {
  width: 100%;
  height: calc(100vh);
  overflow: hidden;
}
</style>
